/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Files_Delete_Dialog_Title_BulkInputs */

const es_settings_files_delete_dialog_title_bulk = /** @type {(inputs: Settings_Files_Delete_Dialog_Title_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Eliminar ${i?.count} archivo(s)?`)
};

const en_settings_files_delete_dialog_title_bulk = /** @type {(inputs: Settings_Files_Delete_Dialog_Title_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.count} file(s)?`)
};

/**
* | output |
* | --- |
* | "Delete {count} file(s)?" |
*
* @param {Settings_Files_Delete_Dialog_Title_BulkInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_delete_dialog_title_bulk = /** @type {((inputs: Settings_Files_Delete_Dialog_Title_BulkInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Delete_Dialog_Title_BulkInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_delete_dialog_title_bulk(inputs)
	return en_settings_files_delete_dialog_title_bulk(inputs)
});
export { settings_files_delete_dialog_title_bulk as "settings.files.delete_dialog.title_bulk" }